/* ============================================================
   FLOWZA — image lightbox + size-chart modal
   No dependency: a library for this would be a third-party script and
   ~30KB for behaviour that is a few pointer maths helpers.

   Lightbox: swipe between shots, pinch to zoom (two pointers), double
   tap / double click to toggle 2x, drag to pan while zoomed, Esc or the
   scrim to close. Focus is trapped and the page behind is locked.
   ============================================================ */
(function () {
  "use strict";

  var lb = document.getElementById("fz-lb");
  if (!lb) return;

  // UI strings from snippets/fz-strings.liquid; the English here is the
  // fallback for a key that is missing.
  var fzT = window.fzT || {};
  function fillIn(s, o) { s = String(s); for (var x in o) s = s.split("[" + x + "]").join(o[x]); return s; }
  function tr(k, en, o) { return fillIn(fzT[k] || en, o); }
  var rtl = document.documentElement.dir === "rtl";

  var imgEl = lb.querySelector(".fz-lb-img");
  var stage = lb.querySelector(".fz-lb-stage");
  var counter = lb.querySelector(".fz-lb-count");
  var shots = [];
  var idx = 0;
  var lastFocus = null;

  // transform state
  var scale = 1, tx = 0, ty = 0;
  var MIN = 1, MAX = 4;

  function apply() {
    imgEl.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
    lb.classList.toggle("is-zoomed", scale > 1.01);
  }
  function reset() { scale = 1; tx = 0; ty = 0; apply(); }

  function show(n) {
    if (!shots.length) return;
    idx = (n + shots.length) % shots.length;
    imgEl.src = shots[idx];
    imgEl.alt = tr("image_of", "Image [n] of [total]", { n: idx + 1, total: shots.length });
    if (counter) counter.textContent = (idx + 1) + " / " + shots.length;
    reset();
  }

  function open(list, start) {
    shots = list;
    lastFocus = document.activeElement;
    lb.hidden = false;
    document.body.style.overflow = "hidden";
    show(start || 0);
    var c = lb.querySelector(".fz-lb-close");
    if (c) c.focus();
  }
  function close() {
    lb.hidden = true;
    document.body.style.overflow = "";
    reset();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ---- triggers: every gallery cell carries its own hi-res source ----
  var cells = Array.prototype.slice.call(document.querySelectorAll("[data-zoom-src]"));
  var sources = cells.map(function (c) { return c.getAttribute("data-zoom-src"); });
  cells.forEach(function (cell, i) {
    var btn = cell.querySelector("[data-lb-open]");
    if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); open(sources, i); });
  });

  lb.addEventListener("click", function (e) {
    if (e.target.closest("[data-lb-close]") || e.target === lb || e.target.classList.contains("fz-lb-scrim")) close();
    if (e.target.closest("[data-lb-prev]")) show(idx - 1);
    if (e.target.closest("[data-lb-next]")) show(idx + 1);
  });
  document.addEventListener("keydown", function (e) {
    if (lb.hidden) return;
    if (e.key === "Escape") close();
    // In RTL the next shot sits to the left.
    if (e.key === "ArrowLeft") show(idx + (rtl ? 1 : -1));
    if (e.key === "ArrowRight") show(idx + (rtl ? -1 : 1));
    if (e.key === "Tab") {
      // keep focus inside the dialog
      var f = lb.querySelectorAll("button:not([hidden])");
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ---- pointer gestures: pinch, pan, swipe, double-tap ----
  var pts = new Map();
  var startDist = 0, startScale = 1, startTx = 0, startTy = 0, startX = 0, startY = 0;
  var lastTap = 0, moved = false;

  function dist() {
    var v = Array.from(pts.values());
    return Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y);
  }
  stage.addEventListener("pointerdown", function (e) {
    stage.setPointerCapture(e.pointerId);
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    moved = false;
    if (pts.size === 2) { startDist = dist(); startScale = scale; }
    else { startX = e.clientX; startY = e.clientY; startTx = tx; startTy = ty; }
  });
  stage.addEventListener("pointermove", function (e) {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 2) {
      var d = dist();
      if (startDist > 0) { scale = Math.min(MAX, Math.max(MIN, startScale * (d / startDist))); apply(); }
      moved = true;
      return;
    }
    var dx = e.clientX - startX, dy = e.clientY - startY;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
    if (scale > 1.01) { tx = startTx + dx; ty = startTy + dy; apply(); }   // pan while zoomed
  });
  function endPointer(e) {
    var had = pts.get(e.pointerId);
    pts.delete(e.pointerId);
    if (pts.size > 0) return;
    if (scale <= 1.01 && had) {
      var dx = e.clientX - startX, dy = e.clientY - startY;
      // swipe only when not zoomed, so panning never changes the image
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { show(idx + ((dx < 0) !== rtl ? 1 : -1)); return; }
    }
    if (!moved) {
      var now = Date.now();
      if (now - lastTap < 300) { scale = scale > 1.01 ? 1 : 2; tx = ty = 0; apply(); lastTap = 0; }
      else lastTap = now;
    }
    if (scale <= 1.01) { tx = 0; ty = 0; apply(); }
  }
  stage.addEventListener("pointerup", endPointer);
  stage.addEventListener("pointercancel", function (e) { pts.delete(e.pointerId); });
  stage.addEventListener("dblclick", function (e) {
    e.preventDefault(); scale = scale > 1.01 ? 1 : 2; tx = ty = 0; apply();
  });
  stage.addEventListener("wheel", function (e) {
    if (lb.hidden) return;
    e.preventDefault();
    scale = Math.min(MAX, Math.max(MIN, scale - e.deltaY * 0.0015));
    if (scale <= 1.01) { tx = 0; ty = 0; }
    apply();
  }, { passive: false });

  // ---- size chart modal: same markup as the on-page chart ----
  var sc = document.getElementById("fz-sc-modal");
  if (sc) {
    var scLast = null;
    function scOpen() {
      scLast = document.activeElement;
      sc.hidden = false; document.body.style.overflow = "hidden";
      var c = sc.querySelector("[data-sc-close]"); if (c) c.focus();
    }
    function scClose() {
      sc.hidden = true; document.body.style.overflow = "";
      if (scLast && scLast.focus) scLast.focus();
    }
    document.querySelectorAll("[data-sc-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); scOpen(); });
    });
    sc.addEventListener("click", function (e) {
      if (e.target.closest("[data-sc-close]") || e.target === sc || e.target.classList.contains("fz-lb-scrim")) scClose();
    });
    document.addEventListener("keydown", function (e) { if (!sc.hidden && e.key === "Escape") scClose(); });
  }
})();
